import {
  ChangeDetectorRef,
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { catchError, first, firstValueFrom, map, throwError } from 'rxjs';

import { Store } from '@ngrx/store';

import { MasterFetchService } from '../../../fetches/services/master-fetch.service';
import { NgRxState } from '../../../modules/app-ngrx.module';
import { MasterAction } from '../../../stored/global/actions';
import { ProviderCodeModel } from '../../../models/common.model';

@Directive({
  selector: '[xbahtMasterPurpose]',
})
export class PurposeDirective implements OnInit {
  constructor(
    private cd: ChangeDetectorRef,
    private ngrxStore: Store<NgRxState>,
    private templateRef: TemplateRef<{
      $implicit: {
        id: string;
        sequence: number;
        name: string;
        provider_code: ProviderCodeModel;
        description: string;
      };
      index: number;
      first: boolean;
      last: boolean;
      even: boolean;
      odd: boolean;
      count: number;
    }>,
    private viewContainer: ViewContainerRef,
    private masterFetchService: MasterFetchService
  ) {}

  async ngOnInit(): Promise<void> {
    const purposes = await firstValueFrom(
      this.ngrxStore.select('Master').pipe(map((item) => item.purposes))
    );
    if (purposes.length != 0) {
      for (let index = 0; index < purposes.length; index++) {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: purposes[index],
          index,
          first: index === 0,
          last: index === purposes.length - 1,
          even: (index & 1) === 0,
          odd: (index & 1) === 1,
          count: purposes.length,
        });
      }

      this.cd.detectChanges();
    } else {
      this.masterFetchService
        .purpose({})
        .pipe(
          first(),
          catchError((error) => throwError(() => error))
        )
        .subscribe((item) => {
          if (item.status && item.payload) {
            this.ngrxStore.dispatch(
              MasterAction.SetPurpose({ purposes: item.payload })
            );

            this.viewContainer.clear();
            for (let index = 0; index < item.payload.length; index++) {
              this.viewContainer.createEmbeddedView(this.templateRef, {
                $implicit: item.payload[index],
                index,
                first: index === 0,
                last: index === item.payload.length - 1,
                even: (index & 1) === 0,
                odd: (index & 1) === 1,
                count: item.payload?.length,
              });
            }

            this.cd.detectChanges();
          }
        });
    }
  }
}
